import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import { useNavigate } from "react-router-dom"; // React Router for navigation
import "./calender.css"; // Import your custom CSS file
import "react-calendar/dist/Calendar.css"; // Default calendar styles
import { getComplianceDashboardCalender } from "../../../services/dashboardImplementor";

const ComplianceCalendar = () => {
  const getUtcDateString = (date: Date): string => {
    const offset = date.getTimezoneOffset() * 60 * 1000;
    const utcDate = new Date(date.getTime() - offset);
    return utcDate.toISOString().split("T")[0];
  };

  const [highlightedDates, setHighlightedDates] = useState<{ [key: string]: any[] }>({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate(); // React Router navigate hook

  useEffect(() => {
    const fetchCalendarData = async () => {
      try {
        setLoading(true);
        const result = await getComplianceDashboardCalender();
        //console.log(result.data?.actionsByDate);
        if (result?.data) {
          setHighlightedDates(result?.data?.actionsByDate); // Store task dates with their data
        }
      } catch (error) {
        console.error("Error fetching calendar data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCalendarData();
  }, []);

  const handleDayClick = (value: Date) => {
    const formattedDate = getUtcDateString(value);
    //console.log("Formatted UTC date:", formattedDate);
    if (highlightedDates[formattedDate]) {
      navigate(`/viewTaskCalender?date=${formattedDate}`);
    }
  };

  const tileClassName = ({ date, view }: { date: Date; view: string }) => {
    if (view === "month") {
      const formattedDate = getUtcDateString(date); // Correctly format date as YYYY-MM-DD
      if (highlightedDates[formattedDate]) {
        return "highlighted-day"; // Add a custom class for highlighted dates
      }
    }
    return null;
  };

  const tileContent = ({ date, view }: { date: Date; view: string }) => {
    if (view === "month") {
      const formattedDate = getUtcDateString(date); // Correctly format date as YYYY-MM-DD
      if (highlightedDates[formattedDate]) {
        return (
          <div className="task-count">
            {highlightedDates[formattedDate].length} tasks
          </div>
        );
      }
    }
    return null;
  };

  return (
    <div>
      {loading ? (
        <p>Loading calendar...</p>
      ) : (
        <Calendar
          tileClassName={tileClassName}
          tileContent={tileContent}
          onClickDay={handleDayClick} // Handle day click
        />
      )}
    </div>
  );
};

export default ComplianceCalendar;
